var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03128 7.89187V0.78125C4.03128 0.648229 4.07618 0.536875 4.16597 0.447187C4.25566 0.357396 4.36701 0.3125 4.50003 0.3125C4.63306 0.3125 4.74441 0.357396 4.8341 0.447187C4.92389 0.536875 4.96878 0.648229 4.96878 0.78125V7.89187L8.19957 4.66109C8.29248 4.56818 8.40123 4.52229 8.52582 4.52344C8.6504 4.52469 8.76118 4.57375 8.85816 4.67063C8.94868 4.7676 8.99555 4.8774 8.99878 5C9.00201 5.1226 8.95514 5.2324 8.85816 5.32937L4.8955 9.29203C4.83696 9.35057 4.77524 9.39182 4.71035 9.41578C4.64545 9.43984 4.57535 9.45187 4.50003 9.45187C4.42472 9.45187 4.35462 9.43984 4.28972 9.41578C4.22483 9.39182 4.16311 9.35057 4.10457 9.29203L0.141909 5.32937C0.0553467 5.24281 0.0110759 5.13562 0.00909672 5.00781C0.00711756 4.88 0.0513884 4.7676 0.141909 4.67063C0.238888 4.57375 0.350243 4.52531 0.475972 4.52531C0.601805 4.52531 0.713211 4.57375 0.810191 4.67063L4.03128 7.89187Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlackIcon);
export default __webpack_public_path__ + "static/media/down-arrow-black-icon.4a57da7e01098e01be7d08e8b0558c7d.svg";
export { ForwardRef as ReactComponent };